import React from "react"

const IconArrowActionable = () => (
<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.8762 7.83232H14.1564V0.281353H6.62397V1.54294L12.0785 1.45018L0.761309 12.7488L1.68895 13.6764L12.969 2.37781L12.8762 7.83232Z"/>
</svg>
)

export default IconArrowActionable